module.exports = __webpack_public_path__ + "static/img/Logan-Smith.9f83b58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logan-Smith.jpg
// module id = kBAS
// module chunks = 0